Vue.component('LanguagesIndexComponent', require('./components/LanguagesIndexComponent').default);
Vue.component('LanguagesGetComponent', require('./components/LanguagesFormComponent').default);
